<script>
  import {getStyleValue, imageUrl} from "../../Common/tools";
  import {External, M} from "../../external";

  export let data, meta, globalStyle, onChange;

  let headingStyle1, headingStyle2, textStyle;

  /*NOTE: these styles are dynamic and change as the user adjusts the widget styling in the toolbar, hence the reactive bindings */

  $: headingStyle1 = "font-family: " + data.heading1.style.fontFamily + "; font-size: " + data.heading1.style.fontSize + "px; font-weight: " + data.heading1.style.fontWeight + "; color: " + data.heading1.style.color;
  $: headingStyle2 = "font-family: " + data.heading2.style.fontFamily + "; font-size: " + data.heading2.style.fontSize + "px; font-weight: " + data.heading2.style.fontWeight + "; color: " + data.heading2.style.color;
  $: textStyle = "font-family: " + data.body.style.fontFamily + "; font-size: " + data.body.style.fontSize + "px; font-weight: " + data.body.style.fontWeight + "; color: " + data.body.style.color;
  $: includeAddressInfo = data.includeAddressInfo !== false;
</script>

<tr>
  <th>
    <table style="width: {getStyleValue(globalStyle.width, 600)}px">
      <tr>
        <td class="column mobile-4" style="padding-left: 40px; width: 130px; text-align: left">
          <img src="{imageUrl(data, External.resources + '/images/marketing/placeholders/100x100.png')}" alt="{M.PRODUCT_NAME}" style="border: 0; width: 100px; height: 100px; max-width: 100px;">
        </td>
        <td class="column mobile-8" style="padding-right: 10px; padding-bottom: 15px; text-align: left">
          <div style={headingStyle1}>1x {M.PRODUCT_NAME}</div>
        </td>
        <td  class="column mobile-8" style="padding-left: 10px; padding-right: 40px; text-align: right">
          <div style={textStyle}>
            {External.Tools.currencyToStrWithSymbol(54)}
          </div>
        </td>
      </tr>
      <!--<tr>
        <td class="column mobile-4" style="padding-left: 40px; width: 130px; text-align: left">
          <img src="{imageUrl(data, External.resources + '/images/marketing/placeholders/100x100.png')}" alt="{M.PRODUCT_NAME}" style="border: 0; width: 100px; height: 100px; max-width: 100px;">
        </td>
        <td class="column mobile-8" style="padding-right: 10px; padding-bottom: 15px; text-align: left">
          <div style={headingStyle1}>{M.PRODUCT_NAME}</div>
        </td>
        <td  class="column mobile-8" style="padding-left: 10px; padding-right: 40px; text-align: right">
          <div style={textStyle}>
            {External.Tools.currencyToStrWithSymbol(54)}
          </div>
        </td>
      </tr>-->
      <tr>
        <td colspan="3" class="column" style="padding: 10px 40px; text-align: left"><div style="border-top: 1px solid #eeeeee; font-size: 0; line-height: 0">&nbsp;</div></td>
      </tr>
      <tr>
        <td colspan="2" class="column mobile-8" style="padding-left: 40px; padding-right: 10px; padding-top: 10px; text-align: left">
          <div style={textStyle}>
            {M.STANDARD_SHIPPING}
          </div>
        </td>
        <td class="column mobile-8" style="padding-left: 10px; padding-top: 10px; padding-right: 40px; text-align: right">
          <div style={textStyle}>
            {External.Tools.currencyToStrWithSymbol(10)}
          </div>
        </td>
      </tr>
      <tr>
        <td colspan="2" class="column mobile-8" style="padding: 15px 10px 10px 40px; text-align: left">
          <div style={headingStyle1}>{M.TOTAL}</div>
        </td>
        <td class="column mobile-8" style="padding: 15px 40px 10px 10px; text-align: right">
          <div style={textStyle}>
            {External.Tools.currencyToStrWithSymbol(118)}
          </div>
        </td>
      </tr>
	  {#if includeAddressInfo}
		<tr>
		  <td colspan="3" class="column" style="padding-bottom: 30px; padding-top: 10px; text-align: left"><div style="border-top: 1px solid #eeeeee; font-size: 0; line-height: 0">&nbsp;</div></td>
		</tr>
		<tr>
		  <td colspan="3" class="column" style="padding-left: 40px">
			<table style="width: 100%">
			  <tr>
				<td class="column mobile-8" style="width: 50%; padding-right: 20px; vertical-align: top !important; text-align: left">
				  <div style={headingStyle2}>
					{M.BILL_TO}:
				  </div>
				  <div style={textStyle}>
					{M.BILLING_ADDRESS}<br>
					{M.RECIPIENT_NAME}<br>
					{M.ADDRESS_LINE_1}<br>
				  </div>
				  <br>
				  <div style={headingStyle2}>
					{M.PAYMENT_INSTRUCTIONS}:
				  </div>
				  <div style={textStyle}>
					{M.LOREM_IPSUM_SHORT}<br>
				  </div>
				</td>
				<td class="column mobile-8" style="width: 50%; vertical-align: top !important; text-align: left">
				  <div style={headingStyle2}>
					{M.SELLER_DETAILS}:
				  </div>
				  <div style={textStyle}>
					<strong>{M.INVOICE_NO}:</strong> 1<br>
					<strong>{M.INVOICE_DATE}:</strong> 01/02/2023 21:30<br>
					{M.COMPANY_NAME}<br>
					{M.COMPANY_PHONE}<br>
					{M.MARKETING_COMPANY_ADDRESS}<br>
				  </div>
				</td>
			  </tr>
			</table>
		  </td>
		</tr>
	  {/if}
    </table>
  </th>
</tr>
